// Mock-Daten für Green Living Website - Ultra Luxury Edition

export const projectData = {
  title: "Green Living",
  subtitle: "Leben am Wasser",
  tagline: "Wohnen im Einklang mit der Natur",
  location: "Lindenstraße 39 A–D, 12527 Berlin-Schmöckwitz",
  videoUrl: "https://customer-assets-gfyr7b9c.emergentagent.net/job_c5e8a38b-4e1f-427f-92df-d371c646c42c/artifacts/l88ueiip_Video%20Draft%201.mp4",
  besichtigungstermin: {
    date: "12.09.2026",
    time: "11:00 - 16:00 Uhr",
    location: "Vor Ort am Wasser",
    recipientEmail: "info@prodomo.gmbh",
    slots: [
      "11:00 - 12:00 Uhr",
      "12:00 - 13:00 Uhr",
      "13:00 - 14:00 Uhr",
      "14:00 - 15:00 Uhr",
      "15:00 - 16:00 Uhr"
    ],
    beschreibung: "Am 12. September 2026 öffnen wir das Ensemble für einen exklusiven Kreis von Interessenten — in kleiner Runde, damit Zeit und Ruhe für jeden Gast bleibt. Entdecken Sie ausgewählte Wohnungen, kommen Sie mit Bauherr und Vertrieb ins Gespräch und lernen Sie diese besondere Immobilie in entspannter Atmosphäre kennen. Wir freuen uns auf Ihren Besuch.",
    hinweisBegrenzt: "Die Gästezahl ist begrenzt. Der Zugang ist ausschließlich mit bestätigter Anmeldung möglich – Ihre persönliche Bestätigung erhalten Sie per E-Mail nach Eingang Ihrer Anfrage."
  },
  logo: "/images/prodomo-logo-white.png",
  logoGold: "/images/prodomo-logo-gold.png",
  images: {
    hero: "/images/visuals/hero.png",
    entrance: "/images/visuals/entrance.png",
    garden: "/images/visuals/garden.png",
    exterior1: "/images/visuals/exterior1.png",
    exterior2: "/images/visuals/exterior2.png",
    sideView: "/images/visuals/sideView.png",
    grundrissHaus1: "/images/visuals/grundriss_haus1.webp",
    grundrissHaus4: "/images/visuals/grundriss_haus4.webp"
  }
};

export const grundrisseData = {
  title: "Wohnen nach Maß",
  subtitle: "Grundrisse mit klarer Raumordnung",
  description: "Vom eleganten Apartment bis zur großzügigen Dachwohnung: Green Living bietet 28 Wohnungen mit einem bis fünf Zimmern — jede mit klarer Raumordnung, viel Tageslicht und einer eigenen Freifläche im Grünen.",
  haeuser: [
    {
      id: 1,
      name: "Haus 1",
      subtitle: "Obergeschoss",
      description: "Großzügige Wohnungen im Obergeschoss mit privaten Terrassenflächen und offenen, lichtdurchfluteten Grundrissen. Klare Raumordnung und durchdachte Wohnkonzepte für den Alltag der kurzen Wege.",
      image: "/images/visuals/grundriss_haus1.webp",
      features: ["Private Terrassenflächen", "Offene Grundrisse", "Viel Tageslicht", "Bis zu 5 Zimmer"]
    },
    {
      id: 4,
      name: "Haus 4",
      subtitle: "Dachgeschoss",
      description: "Wohnungen im Dachgeschoss mit großzügigen Terrassenflächen und weitem Blick, der über Gärten, Wald und Wasser reicht. Zurückgesetzte Staffelgeschosse für ein Wohnen im Licht.",
      image: "/images/visuals/grundriss_haus4.webp",
      features: ["Großzügige Terrassenflächen", "Weiter Blick ins Grüne", "Ruhige Lage", "Sonne von früh bis spät"]
    }
  ],
  hinweis: "Die vollständige Wohnungsübersicht mit allen Grundrissen stellen wir ernsthaft Interessierten gern auf persönliche Anfrage zur Verfügung."
};

export const nachhaltigkeitData = {
  title: "Grün ist hier Programm",
  subtitle: "Nachhaltig und verantwortungsvoll",
  intro: "Green Living ist unser Anspruch – es wurde von Anfang an dafür geplant, seinen Energiebedarf selbst zu erzeugen — sauber, leise und genau dort, wo sie gebraucht wird. So entsteht ein Wohnort, dessen Betrieb weitgehend CO₂-neutral ist.",
  features: [
    {
      id: 1,
      title: "Die Kraft der Sonne",
      subtitle: "auf jedem Dach",
      description: "Alle Dachflächen des Ensembles tragen Photovoltaik mit zusammen 250 kWp Leistung. Energiespeicher in den Häusern halten die Sonnenenergie auch dann bereit, wenn sie gerade nicht scheint — und über ein Mieterstromkonzept wird der eigene Solarstrom direkt im Quartier genutzt, ohne Umweg über das Netz.",
      icon: "sun"
    },
    {
      id: 2,
      title: "Wärme ohne Flamme",
      subtitle: "die Deckenheizung",
      description: "Green Living heizt ohne fossile Brennstoffe: Wärmepumpen und eine innovative elektrische Deckenflächenheizung sorgen für sanfte, gleichmäßige Strahlungswärme — wie Sonnenstrahlen von oben. Unsichtbar in der Decke integriert, ohne Heizkörper an den Wänden, ohne aufgewirbelten Staub.",
      icon: "flame"
    },
    {
      id: 3,
      title: "Effizienz als Fundament",
      subtitle: "KfW-40-Standard",
      description: "Gebaut wurde auf dem Niveau eines KfW-Effizienzhauses 40: hochwertige Gebäudehülle, Dreifach-Verglasung und sommerlicher Wärmeschutz halten die Energie dort, wo sie hingehört. Weniger Verbrauch, mehr Behaglichkeit — Sommer wie Winter.",
      icon: "shield"
    }
  ],
  results: [
    {
      label: "Photovoltaik",
      value: "250 kWp"
    },
    {
      label: "Energiespeicher",
      value: "Mieter\u00ADstrom\u00ADkonzept"
    },
    {
      label: "Heizung",
      value: "CO₂-neutral"
    },
    {
      label: "Standard",
      value: "KfW-40"
    }
  ]
};

export const kontaktData = {
  title: "Persönlich. Diskret. Erreichbar.",
  intro: "Der Vertrieb von Green Living – Leben am Wasser liegt in den Händen der ProDomo Projektentwicklung GmbH — Ihrem persönlichen Ansprechpartner für diese besondere Immobilie. In der Kundenbetreuung unterstützt die Content Immobilien GmbH als Kooperationspartnerin.",
  firmen: [
    {
      name: "ProDomo Projektentwicklung GmbH",
      beschreibung: "Vertriebspartner · Ihr Ansprechpartner für Vertrieb & Beratung",
      email: "info@prodomo.gmbh",
      logo: "/images/prodomo-logo-white.png",
      logoAlt: "ProDomo Projektentwicklung GmbH",
      logoClasses: "w-20 h-20 md:w-24 md:h-24 object-contain",
      logoBg: "dark",
      istHauptpartner: true
    },
    {
      name: "Content Immobilien GmbH",
      beschreibung: "Kooperationspartnerin · Vertrieb & Beratung",
      email: "d.maess@content-immobilien.de",
      logo: "/images/content_immobilien_logo.png",
      logoAlt: "Content Immobilien GmbH",
      logoClasses: "w-40 md:w-48 object-contain",
      logoBg: "light",
      istHauptpartner: false
    }
  ],
  ansprechpartner: [
    {
      name: "Christian Döpper",
      firma: "ProDomo",
      rolle: "Vertrieb & Beratung",
      telefon: "+49 162 411 275 7"
    },
    {
      name: "Reiner Kraatz",
      firma: "ProDomo",
      rolle: "Vertrieb & Beratung",
      telefon: "+49 171 492 138 2"
    },
    {
      name: "Daniela Mäß",
      firma: "Content",
      rolle: "Vertrieb & Beratung",
      telefon: "+49 172 348 895 1",
      email: "d.maess@content-immobilien.de"
    }
  ],
  projekttraeger: "Triple A Verwaltungsgesellschaft mbH",
  vertrieb: "ProDomo Projektentwicklung GmbH"
};

// ===== A1 · Impressum (§ 5 DDG) =====
export const impressumData = {
  title: "Impressum",
  intro: "Angaben gemäß § 5 DDG",
  groups: [
    {
      heading: "Betreiber der Website · Vertriebspartner",
      lines: [
        "ProDomo Projektentwicklung GmbH",
        "Holunderweg 6, 14641 Wustermark",
        "Vertreten durch den Geschäftsführer: Christian Döpper",
        "Registergericht: Amtsgericht Potsdam · HRB 41174P",
        "Telefon: +49 162 411 275 7",
        "E-Mail: info@prodomo.gmbh"
      ]
    },
    {
      heading: "Berufsrechtliche Angaben (§ 34c GewO)",
      lines: [
        "Berufsbezeichnung: Immobilienmakler (verliehen in der Bundesrepublik Deutschland)",
        "Erlaubnis nach § 34c Abs. 1 GewO",
        "Erteilende und zuständige Aufsichtsbehörde: Gemeinde Wustermark, Hoppenrader Allee 1, 14641 Wustermark",
        "Berufsrechtliche Regelungen: § 34c GewO, Makler- und Bauträgerverordnung (MaBV) — einsehbar unter www.gesetze-im-internet.de"
      ]
    }
  ]
};

// ===== A2 · Datenschutzerklärung (DSGVO / TDDDG) =====
export const datenschutzData = {
  title: "Datenschutzerklärung",
  intro: "Wir freuen uns über Ihr Interesse an Green Living – Leben am Wasser. Der Schutz Ihrer personenbezogenen Daten ist uns ein wichtiges Anliegen. Nachfolgend informieren wir Sie gemäß der Datenschutz-Grundverordnung (DSGVO) und dem TDDDG über die Verarbeitung Ihrer Daten auf dieser Website.",
  sections: [
    {
      title: "1. Verantwortlicher",
      paragraphs: [
        "Verantwortlich für die Datenverarbeitung auf dieser Website ist:",
        "ProDomo Projektentwicklung GmbH, Holunderweg 6, 14641 Wustermark",
        "E-Mail: info@prodomo.gmbh · Telefon: 0162 4112757"
      ]
    },
    {
      title: "2. Datenschutzbeauftragter",
      paragraphs: [
        "Ein Datenschutzbeauftragter wurde nicht benannt, da die gesetzlichen Voraussetzungen für eine Benennungspflicht nicht vorliegen."
      ]
    },
    {
      title: "3. Kontakt- und Anmeldeformular",
      paragraphs: [
        "Wenn Sie unser Kontakt- bzw. Anmeldeformular nutzen, verarbeiten wir die von Ihnen angegebenen Daten: Name, E-Mail-Adresse, Telefonnummer sowie Ihre Nachricht.",
        "Zwecke der Verarbeitung: Bearbeitung Ihrer Anfrage, Organisation von Besichtigungsterminen (u. a. Besichtigungstag am 12.09.2026, Gästeliste), Versand von Unterlagen (Preisliste, Grundrisse und weiterer Projektinformationen) sowie die anschließende Vertriebskommunikation.",
        "Rechtsgrundlagen: Art. 6 Abs. 1 lit. b DSGVO (Durchführung vorvertraglicher Maßnahmen auf Ihre Anfrage) sowie ergänzend Art. 6 Abs. 1 lit. f DSGVO (unser berechtigtes Interesse an der Beantwortung und Dokumentation Ihrer Anfrage)."
      ]
    },
    {
      title: "4. Empfänger der Daten",
      paragraphs: [
        "Empfänger Ihrer Daten ist ausschließlich die ProDomo Projektentwicklung GmbH. Eine Übermittlung an weitere Empfänger findet nur statt, soweit dies zur Abwicklung Ihres Kaufinteresses erforderlich ist. Eine Übermittlung in Drittländer erfolgt nur im Rahmen des Hostings (siehe Ziffer 6)."
      ]
    },
    {
      title: "5. Speicherdauer",
      paragraphs: [
        "Wir löschen Ihre Daten, sobald der Zweck der Verarbeitung entfällt, sofern keine gesetzlichen Aufbewahrungspflichten entgegenstehen. Bei Interessenten ohne weiteren Kontakt erfolgt die Löschung spätestens 12 Monate nach dem letzten Kontakt."
      ]
    },
    {
      title: "6. Hosting & Server-Logfiles",
      paragraphs: [
        "Diese Website wird auf der Plattform Emergent (Emergent Agent Inc., 340 S Lemon Ave #1275, Walnut, CA 91789, USA) gehostet. Da die Server außerhalb der EU stehen können, findet eine Datenübermittlung in ein Drittland (USA) statt. Diese ist auf Grundlage von Standardvertragsklauseln der EU-Kommission gemäß Art. 46 Abs. 2 lit. c DSGVO abgesichert. Mit dem Anbieter besteht ein Auftragsverarbeitungsvertrag.",
        "Die Domain greenliving-lebenamwasser.de ist über IONOS SE, Elgendorfer Str. 57, 56410 Montabaur, registriert.",
        "Beim Aufruf der Website werden automatisch Server-Logfiles (IP-Adresse, Zeitstempel, aufgerufene Seite, User-Agent) erhoben. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einem sicheren und stabilen Betrieb)."
      ]
    },
    {
      title: "7. Cookies & Tracking",
      paragraphs: [
        "Wir setzen ausschließlich technisch notwendige Cookies ein, für die keine Einwilligung erforderlich ist.",
        "Sollten künftig Analyse- oder Marketing-Dienste (z. B. Meta-Pixel, Google-Ads-Conversion, Web-Analyse) eingebunden werden, erfolgt dies erst nach Ihrer ausdrücklichen Einwilligung über ein Consent-Banner (Opt-in) vor dem Laden der jeweiligen Skripte gemäß § 25 TDDDG. Für jeden Dienst werden dann Anbieter, Zweck, ein etwaiger Drittlandtransfer, die Speicherdauer sowie die Widerrufsmöglichkeit gesondert ausgewiesen. Aktueller Stand: Es findet kein Tracking, keine Web-Analyse und kein Marketing-Tracking statt."
      ]
    },
    {
      title: "8. Ihre Rechte",
      paragraphs: [
        "Sie haben das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung, Datenübertragbarkeit sowie Widerspruch gegen die Verarbeitung. Erteilte Einwilligungen können Sie jederzeit mit Wirkung für die Zukunft widerrufen.",
        "Ihnen steht zudem ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu: Die Landesbeauftragte für den Datenschutz und für das Recht auf Akteneinsicht Brandenburg."
      ]
    }
  ],
  formHinweis: "Mit dem Absenden werden Ihre Angaben zur Bearbeitung Ihrer Anfrage und zur Terminvereinbarung verarbeitet. Einzelheiten: siehe Datenschutzerklärung."
};

// ===== A4 · Energieausweis (§ 87 GEG) =====
export const energieausweisData = {
  title: "Angaben zum Energieausweis",
  badge: "Vorläufige Berechnung",
  columns: ["Haus 1 & 2", "Haus 3 & 4"],
  rows: [
    { label: "Primärenergiebedarf", haus12: "19,91 kWh/(m²·a)", haus34: "15,25 kWh/(m²·a)" },
    { label: "Energieeffizienzklasse", haus12: "A+", haus34: "A+" },
    { label: "Wesentlicher Energieträger", both: "Strom — Wärmepumpe / Photovoltaik" },
    { label: "Energetischer Standard", both: "KfW-Effizienzhaus 40 (EnEV 2023)" },
    { label: "Baujahr / Fertigstellung", both: "Neubau — Fertigstellung 2026" }
  ],
  fussnote: "Vorläufige Energiebedarfsberechnung nach DIN V 18599 / GEG (Stand 08.06.2023) — je Gesamtgebäude Haus 1+2 bzw. Haus 3+4. Dies ist ausdrücklich nicht der endgültige Energieausweis: Die endgültigen Energieausweise werden nach Fertigstellung (2026) mit Registriernummer ausgestellt. Angaben gemäß § 87 GEG."
};

// ===== A5 · Provision + A6 · Disclaimer + Urheberrecht =====
export const rechtlichesData = {
  title: "Rechtliche Hinweise",
  sections: [
    {
      title: "Provision",
      content: "Die Maklerprovision beträgt insgesamt 7,14 % inkl. MwSt. des beurkundeten Kaufpreises und wird gemäß § 656c BGB zwischen Käufer und Verkäufer hälftig geteilt. Käuferanteil: 3,57 % inkl. MwSt., verdient und fällig mit Abschluss des notariellen Kaufvertrages."
    },
    {
      title: "Haftung & Angaben",
      content: "Alle Angaben beruhen auf den derzeit vorliegenden Informationen des Eigentümers, Bauherrn bzw. Projektentwicklers und wurden mit Sorgfalt zusammengestellt. Für Richtigkeit, Vollständigkeit und Aktualität wird keine Gewähr übernommen. Irrtümer, Änderungen und Zwischenverkauf bleiben vorbehalten. Abbildungen und Visualisierungen dienen der Veranschaulichung und können Sonderausstattungen oder Gestaltungsvorschläge enthalten, die nicht Bestandteil des Kaufgegenstandes sind. Maßgeblich sind ausschließlich der notarielle Kaufvertrag, die Baubeschreibung und die darin einbezogenen Vertragsunterlagen. Flächenangaben sind Circa-Angaben. Dieses Angebot ist freibleibend und stellt kein rechtlich bindendes Angebot dar."
    },
    {
      title: "Urheberrecht",
      content: "© 2026 Green Living – Leben am Wasser · Alle Rechte vorbehalten. Weitergabe und Vervielfältigung der Inhalte nur mit Zustimmung des Anbieters."
    },
    {
      title: "KI-Transparenz",
      content: "Transparenzhinweis gemäß Art. 50 Abs. 4 der Verordnung (EU) 2024/1689 (KI-Verordnung): Die auf dieser Website gezeigten Visualisierungen von Außen- und Innenansichten sowie Grundrissdarstellungen wurden mit Hilfe künstlicher Intelligenz bearbeitet. Diese Bildinhalte sind mit dem offiziellen EU-Kennzeichen „AI MODIFIED“ und dem Hinweis „Mit KI bearbeitet“ gekennzeichnet. Es handelt sich um unverbindliche Darstellungen zur Veranschaulichung; sie können vom finalen baulichen Ergebnis abweichen. Logos, Textinhalte, Grafikelemente sowie nicht KI-bearbeitete Fotografien sind von dieser Kennzeichnung ausgenommen."
    }
  ],
  copyright: "© 2026 Green Living – Leben am Wasser · Alle Rechte vorbehalten. Weitergabe und Vervielfältigung der Inhalte nur mit Zustimmung des Anbieters."
};
